  
<template>
  <!-- note: by using red base images for buttons, can tint (HSV) using filter: hue-rotate(); etc. -->

  <div class="mainUI" id="uiDiv" oncontextmenu="return false;">
    <!-- top-left -->
    <div
      class="regionUI skyColor"
      style="top: 10px; left: 10px"
      oncontextmenu="return false;"
    ></div>

    <!-- top-right -->
    <div class="regionUI" style="top: 10px; right: 10px"></div>

    <!-- bottom-left -->

    <!-- bottom-right -->
    <!-- <div class="regionUI" style="bottom: 10px; right: 10px; z-index:-2">
      <div class="buttonUI" style=" opacity:0.80;">
        <img src="/img/joystick-base.png" />
        <div id="stick2" style="position: absolute; left:32px; bottom:32px; width: 100vw; height: 100vh">
          <img src="/img/joystick-blue.png" />
        </div>
      </div>
    </div>-->
    <img class="stick-base" src="/img/joystick-base.svg" style />
    <div class="regionUI" style="bottom: 10px; left: 10px" >
      <div class="buttonUI" style>
        <div id="stick1" class="stick">
          <img src="/img/handle.svg" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable */
export default {
  props: ["startAnimEnded"],
  mounted: function () {
    /*eslint-disable */

    class Joystick {
      // stickID: ID of HTML element (representing joystick) that will be dragged
      // maxDistance: maximum amount joystick can move in any direction
      // deadzone: joystick must move at least this amount from origin to register value change
      constructor(stickID, maxDistance, deadzone) {
        this.id = stickID;
        let stick = document.getElementById(stickID);

        // location from which drag begins, used to calculate offsets
        this.dragStart = null;

        // track touch identifier in case multiple joysticks present
        this.touchId = null;

        this.active = false;
        this.value = { x: 0, y: 0 };

        let self = this;

        function handleDown(event) {
          self.active = true;

          // all drag movements are instantaneous
          stick.style.transition = "0s";

          // touch event fired before mouse event; prevent redundant mouse event from firing
          event.preventDefault();

          if (event.changedTouches)
            self.dragStart = {
              x: event.changedTouches[0].clientX,
              y: event.changedTouches[0].clientY,
            };
          else self.dragStart = { x: event.clientX, y: event.clientY };

          // if this is a touch event, keep track of which one
          if (event.changedTouches)
            self.touchId = event.changedTouches[0].identifier;
        }

        function handleMove(event) {
          if (!self.active) return;

          // if this is a touch event, make sure it is the right one
          // also handle multiple simultaneous touchmove events
          let touchmoveId = null;
          if (event.changedTouches) {
            for (let i = 0; i < event.changedTouches.length; i++) {
              if (self.touchId == event.changedTouches[i].identifier) {
                touchmoveId = i;
                event.clientX = event.changedTouches[i].clientX;
                event.clientY = event.changedTouches[i].clientY;
              }
            }

            if (touchmoveId == null) return;
          }

          const xDiff = event.clientX - self.dragStart.x;
          const yDiff = event.clientY - self.dragStart.y;
          const angle = Math.atan2(yDiff, xDiff);
          const distance = Math.min(maxDistance, Math.hypot(xDiff, yDiff));
          const xPosition = distance * Math.cos(angle);
          const yPosition = distance * Math.sin(angle);

          if (stickID !== "stick2") {
            // move stick image to new position
            stick.style.transform = `translate3d(${xPosition}px, ${yPosition}px, 0px)`;
          }

          // deadzone adjustment
          const distance2 =
            distance < deadzone
              ? 0
              : (maxDistance / (maxDistance - deadzone)) *
                (distance - deadzone);
          const xPosition2 = distance2 * Math.cos(angle);
          const yPosition2 = distance2 * Math.sin(angle);
          const xPercent = parseFloat((xPosition2 / maxDistance).toFixed(4));
          const yPercent = parseFloat((yPosition2 / maxDistance).toFixed(4));

          self.value = { x: xPercent, y: yPercent };
        }

        function handleUp(event) {
          if (!self.active) return;

          // if this is a touch event, make sure it is the right one
          if (
            event.changedTouches &&
            self.touchId != event.changedTouches[0].identifier
          )
            return;

          // transition the joystick position back to center
          stick.style.transition = ".2s";
          stick.style.transform = `translate3d(0px, 0px, 0px)`;

          // reset everything
          self.value = { x: 0, y: 0 };
          self.touchId = null;
          self.active = false;
        }

        stick.addEventListener("mousedown", handleDown);
        stick.addEventListener("touchstart", handleDown);
        document.addEventListener("mousemove", handleMove, { passive: false });
        document.addEventListener("touchmove", handleMove, { passive: false });
        document.addEventListener("mouseup", handleUp);
        document.addEventListener("touchend", handleUp);
      }
    }
    // need to run javascript code after a-scene entities and components are loaded
    AFRAME.registerComponent("screen-controls", {
      init: function () {
        this.component = document.getElementById("camera").components[
          "extended-wasd-controls"
        ];
        this.joystick1 = new Joystick("stick1", 64, 8);
        this.joystick2 = new Joystick("stick2", 64, 8);
      },

      tick: function (time, deltaTime) {
        // console.log( joystick1.value )
        // console.log( this.component.movePercent )
        this.component.movePercent.x = this.joystick1.value.x;
        this.component.movePercent.z = -this.joystick1.value.y;
        this.component.rotatePercent.x = -this.joystick2.value.y * 2;
        this.component.rotatePercent.y = -this.joystick2.value.x * 2;
      },
    });
  },
};
</script>
<style scoped lang="scss">
.stick-base {
  position: absolute;
  right: 29px;
  bottom: 30px;
}
.stick {
  position: absolute;
  right: 35px;
  bottom: 29px;
}
</style>